import {
  LIST_RECIPIENT_LISTS,
  CLEAR_RECIPIENT_LISTS,
  LIST_RECIPIENT_DIPPING,
  SET_RECIPIENT_LIST_DEDUPLICATION,
} from "../actions/recipientLists";

export default function recipientListsReducer(
  recipientLists = null,
  {
    type,
    recipientLists: newRecipientLists,
    dippingList,
    recipientListId,
    completed,
    updatedAt,
  }
) {
  switch (type) {
    case LIST_RECIPIENT_LISTS:
      return {
        ...newRecipientLists,
        // Keep dedupe completion markers across long-poll refreshes.
        dedupeStatusById: recipientLists?.dedupeStatusById ?? {},
      };
    case CLEAR_RECIPIENT_LISTS:
      return null;
    case LIST_RECIPIENT_DIPPING:
      if (recipientLists && dippingList) {
        // Need refactor for performance cost, bulk instead of individual
        return {
          ...recipientLists,
          dipStatus: {
            ...recipientLists.dipStatus,
            [dippingList.recipientListId]: dippingList,
          },
        };
      }
      return recipientLists;
    case SET_RECIPIENT_LIST_DEDUPLICATION: {
      if (!recipientLists || !recipientListId) return recipientLists;

      return {
        ...recipientLists,
        dedupeStatusById: {
          ...(recipientLists.dedupeStatusById ?? {}),
          [recipientListId]: {
            completed: Boolean(completed),
            updatedAt: updatedAt ?? Date.now(),
          },
        },
      };
    }
    default:
      return recipientLists;
  }
}
